import { useMutation } from "urql";
import { graphql } from "../gql";

const deleteSourceMutation = graphql(`
  mutation DeleteSourceMutation($bucket: String!, $id: ID!, $hash: String!) {
    removeSource(bucket: $bucket, id: $id, hash: $hash) {
      ...SongFields
    }
  }
`);

export function useDeleteSource() {
  const [mutationResult, executeMutation] = useMutation(deleteSourceMutation);

  const deleteSource = async (
    bucket: string,
    id: string,
    hash: string,
  ): Promise<boolean> => {
    const result = await executeMutation({
      bucket,
      id,
      hash,
    });

    if (result.error) {
      console.error("Fehler beim Löschen der Quelldatei:", result.error);
      return false;
    }

    return result.data?.removeSource !== undefined;
  };

  return {
    deleteSource,
    fetching: mutationResult.fetching,
    error: mutationResult.error,
  };
}
